<template>
	<div class="kehuchaxun">
		<el-scrollbar id="menuWarpper" style="height:calc(100%);">
			<el-main>
				<div class="header" ref="header">
					<div class="headerTop">
						<div class="header-con">
							<el-form class="header-con-form" :inline="true">
								<el-form-item class="header-con-form-item" label="客户名称:">
									<el-input v-model="kehumingcheng" class="form-item-inputcpx" placeholder="请输入"
										@keyup.enter.native="ChaXun(1)">
									</el-input>
								</el-form-item>

								<el-form-item class="header-con-form-item" label="起始日期:">
									<el-date-picker class="form-item-inputcpx" :clearable="false"
										v-model="kaishishijian" type="date" range-separator="至"
										value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item class="header-con-form-item" label="终止日期:">
									<el-date-picker class="form-item-inputcpx" :clearable="false"
										v-model="jieshushijian" type="date" range-separator="至"
										value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>

							</el-form>
							<el-button type="success" @click="ChaXun(1)" :disabled="isChaXun">查询</el-button>
						</div>

					</div>
				</div>
				<div class="main" v-bind:style="{height:EchartsHeight}">
					<el-table :data="tableData" height="100%" highlight-current-row resizable stripe border>
						<el-table-column align="center" type="index" label="序号" width="50" show-overflow-tooltip>
						</el-table-column>
						<el-table-column align="center" prop="CODE" label="工单编号" width="100" show-overflow-tooltip>
						</el-table-column>
						<el-table-column align="center" prop="COMPANY" label="客户名称 " min-width="180" show-overflow-tooltip>
						</el-table-column>
						<el-table-column align="center" prop="CONTACT" label="客户联系人" show-overflow-tooltip>
						</el-table-column>

						<el-table-column align="center" prop="CONTACT_INFORMATION" label="联系方式" width="100"
							show-overflow-tooltip>
						</el-table-column>
						<el-table-column align="center" prop="STATUS" label="状态" width="100" show-overflow-tooltip>
							<template slot-scope="scope">



								<!-- <el-button type="danger" @click="shanchu(scope)"
										v-if="scope.row.ACCOUNT_STATUS!=0&&jueseID!=11" :disabled="isQiYong">删除</el-button> -->

								<div type="danger" v-if="scope.row.STATUS==0">已删除</div>
								<div type="danger" v-if="scope.row.STATUS==1">未发布</div>
								<div type="danger" v-if="scope.row.STATUS==2">已发布</div>
							</template>
						</el-table-column>


						<el-table-column align="center" prop="UPDATED_TIME" label="更新时间" show-overflow-tooltip>
							<template v-if="scope.row.UPDATED_TIME!=null" slot-scope="scope">
								{{scope.row.UPDATED_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

							</template>
						</el-table-column>
						<el-table-column align="center" label="操作" width="230px" fixed="right">
							<template slot-scope="scope">



								<!-- <el-button type="danger" @click="shanchu(scope)"
									v-if="scope.row.ACCOUNT_STATUS!=0&&jueseID!=11" :disabled="isQiYong">删除</el-button> -->

								<el-button type="primary" style="margin-top: 10px;" @click="BianJi(scope)">编辑</el-button>
								<el-button type="warning" style="margin-top: 10px;" @click="ChaKan(scope)">查看</el-button>
								<el-button type="danger" v-if="scope.row.STATUS!=0" @click="ShanChu('删除',scope)">删除
								</el-button>
								<el-button type="success" style="margin-top: 10px;" v-if="scope.row.STATUS==1" @click="ShanChu('发布',scope)">发布
								</el-button>
								<el-button type="success" style="margin-top: 10px;" v-if="scope.row.STATUS==2" @click="ShanChu('取消发布',scope)">取消发布
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="footer" ref="footer">
					<pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage" @hanSiChange="hanSiChange"
						@hanCurrChange="hanCurrChange"></pagination>
				</div>
			</el-main>
		</el-scrollbar>
	</div>
</template>

<script>
	import PinyinMatch from "pinyin-match";
	export default {
		name: "faqisssqlb",
		data() {
			return {
				kaishishijian: "",
				jieshushijian: "",
				isChaXun: false,
				isQiYong: false,
				zhanghaozhuangtai: '-1',
				EchartsHeight: (document.body.clientHeight - 200) + 'px',
				jueseID: JSON.parse(localStorage.getItem("userInfo")).ROLE,
				xingji: 4,
				miaoshu: "",
				pingjiaxuanzhong: 0,
				formDialog: false,
				formxjgdlog: false,
				formxzkhlog: false,
				colors: ['#FFFF00', '#FFFF00', '#FFFF00', '#FFFF00', '#FFFF00'],
				staffcopy: [{
						Code: "-1",
						Name: "全部"
					},
					{
						Code: "2",
						Name: "启用"
					},
					{
						Code: "3",
						Name: "禁用"
					}
				],
				staff: [{
						Code: "-1",
						Name: "全部"
					},
					{
						Code: "2",
						Name: "启用"
					},
					{
						Code: "3",
						Name: "禁用"
					}
				], //状态
				staffz: [{
						Code: "-1",
						Name: "全部"
					},
					{
						Code: "2",
						Name: "启用"
					},
					{
						Code: "3",
						Name: "禁用"
					}
				], //状态
				kehumingcheng: "",
				templateName: "",
				loading: false,
				currPage: 1,
				pageSize: 0,
				allPage: 0,
				value: "",
				shijian: "",
				tableData: [],
				WenTileixingList: [],
				sfdycjr: 0,

			};
		},

		mounted() {
			this.addDate()
			const that = this;
			window.onresize = () => {
				// return (() => {
				window.screenHeight = document.body.clientHeight
				that.EchartsHeight = (window.screenHeight - 200) + 'px'
				that.EchartsHeightxjgd = (window.screenHeight - 200) + 'px'
				// })()
			}

			this.currPage = 1;
			this.ChaXun(this.currPage);

		},
		// activated() {
		// 	this.addDate()
		// 	const that = this;
		// 	window.onresize = () => {
		// 		// return (() => {
		// 		window.screenHeight = document.body.clientHeight
		// 		that.EchartsHeight = (window.screenHeight - 200) + 'px'
		// 		that.EchartsHeightxjgd = (window.screenHeight - 200) + 'px'
		// 		// })()
		// 	}

		// 	this.currPage = 1;
		// 	this.ChaXun(this.currPage);
		// },
		beforeRouteEnter(to, form, next) {
			next(vm => {
				vm.ChaXun(1)

			})

		},
		methods: {
			dianjichanpinxian() {
				this.staff = this.staffz;
				this.ChaXun(1)
			},
			bindSelectChange(val) {

				if (val) {
					this.staff = this.staffcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.staff = this.staffcopy
				}

			},



			//查询
			ChaXun(index) {
				this.currPage = index;

				this.loading = true;
				this.isChaXun = true;
				window.localStorage.setItem('faqisssstartDate', this.kaishishijian)
				window.localStorage.setItem('faqisssendDate', this.jieshushijian)
				this.$request({
						method: "GET",
						url: '/Implement/LaunchList?custome=' + encodeURIComponent(this.kehumingcheng) +
							"&startDate=" +
							encodeURIComponent(
								this.kaishishijian + " 00:00:00") + "&endDate=" + encodeURIComponent(this
								.jieshushijian + " 23:59:59") +
							"&pageIndex=" + encodeURIComponent(index) + "&pageSize=" + encodeURIComponent(this
								.pageSize)

					})
					.then((res) => {
						this.isChaXun = false;
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							this.tableData = res.Data;

						}
						this.allPage = res.Total;
					})
					.catch((err) => {
						this.isChaXun = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});


			},
			/**修改 */
			BianJi(row) {
				console.log(row)
				this.$router.push({
					path: "shishishenqingbianji",
					query: {
						zhuangtai: 'N',
						qianyiyemingcheng: '实施申请编辑',
						CODE: row.row.CODE,
						qianyiyemianglujing: "/home/shishishenqingbianji"
					}
				});
			},
			ChaKan(row) {
				console.log(row)
				this.$router.push({
					path: "shishishenqingxq",
					query: {
						zhuangtai: 'N',
						qianyiyemingcheng: '实施申请查看',
						CODE: row.row.CODE,
						qianyiyemianglujing: "/home/shishishenqingxq"
					}
				});
			},


			/**删除 */
			ShanChu(value, row) {
				console.log(value, row)
				this.genggaizhuangtai(value, row.row.CODE)
			},
			/**更改状态*/
			genggaizhuangtai(value, CODE) {
				var status = 0;
				if (value == "删除") {
					status = 0;
				} else if (value == "发布") {
					status = 2;
				} else {
					status = 1;
				}
				let data = {

					CODE: CODE, //序号
					STATUS: status, //客服工号


				};
				this.$request({
						method: "post",
						url: "/Implement/StatusModify",
						data: data,
					})
					.then((res) => {
						this.isQiYong = false;
						this.$message({
							message: "单号为" + CODE + value + res.Msg,
							type: "success",
						});
						this.ChaXun(this.currPage)

					})
					.catch((err) => {
						this.isQiYong = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			addDate() {
				let nowDate = new Date();
				let date = {
					year: nowDate.getFullYear(),
					month: nowDate.getMonth() + 1,
					date: nowDate.getDate(),
				};
				console.log(date);

				if (date.month > 0 && date.month < 10) {
					date.month = '0' + date.month; //补齐
				}
				if (date.date > 0 && date.date < 10) {
					date.date = '0' + date.date; //补齐
				}
				nowDate.setMonth(nowDate.getMonth() - 1);
				var thirtyYear = nowDate.getFullYear();
				var thirtyMonth = nowDate.getMonth() + 1;
				var thirtyDay = nowDate.getDate();
				if (thirtyMonth >= 1 && thirtyMonth <= 9) {
					thirtyMonth = "0" + thirtyMonth;
				}
				if (thirtyDay >= 1 && thirtyDay <= 9) {
					thirtyDay = "0" + thirtyDay;
				}
				var monthDate = thirtyYear + "-" + thirtyMonth + "-" + '01';
				console.log(date.date, monthDate);
				// let shijianshuzu = [];
				let shijian = date.year + "-" + date.month + "-" + date.date;

				// shijianshuzu.push(shijian);
				// shijianshuzu.push(shijian);
				this.kaishishijian = monthDate;
				this.jieshushijian = shijian;
				this.yujiwanchengshijian = shijian + " 23:59:59";
				console.log(this.kaishishijian,this.jieshushijian)
				if (window.localStorage.getItem('faqisssstartDate') != "null" && window.localStorage.getItem(
						'faqisssstartDate') != "") {
					this.kaishishijian = window.localStorage.getItem('faqisssstartDate');
					this.jieshushijian = window.localStorage.getItem('faqisssendDate');
				}
				console.log(this.kaishishijian,this.jieshushijian)
			},

			/**分页size改变 */
			hanSiChange(val) {
				this.pageSize = val;
				this.currPage = 1;
				this.ChaXun(this.currPage);
			},
			/**当前页改变 */
			hanCurrChange(val) {
				this.currPage = val;
				this.ChaXun(this.currPage);
			},
			/**刷新表格数据 */
			handleRefresh() {
				this.currPage = 1;
				this.ChaXun(this.currPage);
			},


		},
	};
</script>

<style scoped>
	.kehuchaxun {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		/* padding: 20px; */
		padding-left: 0px;
		background-color: #F0F0F0;
	}

	.el-main {
		background-color: #F0F0F0;
		padding: 0px;
	}


	/* 头部选择模板名称 */
	.header {
		height: 60px;
		background-color: #FFFFFF;
		padding-left: 20px;
		padding-top: 20px;
		/* width: calc(100%-10px); */
	}

	.headerTop {
		display: flex;
		justify-content: space-between;
	}

	.header-con {
		height: 40px;
		/* width: calc(100%-200px); */
		display: flex;
		align-items: center;
	}

	.header-con-form {
		display: flex;
		align-items: center;
	}

	.header-con-form-item {
		margin-bottom: 0;
	}

	/deep/ .el-dialog {
		max-height: 80%;
	}


	/* 主体容器 */
	.main {
		margin-top: 10px;

		overflow-y: auto;
		margin-right: 0px;
	}


	/**输入框宽度 */
	.input {
		width: 200px;
	}

	/**dialog中样式 */
	.dialog-con {
		height: 375px;
		overflow: auto;
	}

	/**dialog中样式 */
	.dialog-cona {
		height: auto;
		overflow: auto;
	}

	/**底部分页 */
	.footer {
		height: 50px;
		margin-right: 0px;
	}

	/**输入框宽度 */
	.form-item-inputcpx {
		width: 180px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatarxjgd {
		width: 178px;
		height: 178px;
		display: block;
	}

	.el-card {
		box-shadow: 0 1px 1px #F5F5F5 !important;
	}

	/deep/.eloption .el-select-dropdown__wrap {
		max-height: 400px !important;
	}

	.el-table {
		overflow-y: auto !important;
		overflow-x: auto !important;
	}
</style>
